<template>
  <div class="progressWrap">
    <svg class="progress-ring" :height="this.radius * 2" :width="this.radius * 2">
      <circle class="bar" :r="normalizedRadius" :cx="radius" :cy="radius" />
      <circle :stroke-dasharray="circumference + ' ' + circumference" :style="{ strokeDashoffset }" :stroke-width="8" :r="normalizedRadius" :cx="radius" :cy="radius" />
    </svg>
    <div class="value" v-if="showValue">{{ this.progress }}%</div>
  </div>
</template>
<script>
export default {
  props: {
    progress: Number,
    radius: Number,
    showValue: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    const normalizedRadius = this.radius - 8;
    const circumference = normalizedRadius * 2 * Math.PI;

    return {
      normalizedRadius,
      circumference,
    };
  },
  computed: {
    strokeDashoffset() {
      return this.circumference - (this.progress / 100) * this.circumference;
    },
  },
};
</script>
<style scoped>
.progress-ring circle {
  animation: percent 1s linear;
  fill: transparent;
  stroke: #47d061;
  stroke-linecap: round;
}
.progress-ring circle.bar {
  stroke: #bbbbbb;
  stroke-width: 5px;
}
.progressWrap {
  display: flex;
  position: relative;
}
.value {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@keyframes percent {
  0% {
    stroke-dashoffset: 0;
    stroke-width: 0;
  }
}
</style>
